import { apiUrl } from './tool'
import axios from 'axios'

const useMock = false

export function getCareAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "paginate": {
          "page": "1",
          "limit": "20",
          "page_total": "1",
          "total": "2"
        },
        "data": [
          {
            "id": "22",
            "name": "蔡有人",
            "phone": "0922099195",
            "start_time": "2022-08-26 18:55",
            "doctor_name": "王醫師",
            "note": "test",  //約診備註
            "create_time": "2022-09-01 17:22",
            "content": "補牙崩落",  //病患不舒服內容
            "clinic_call": "1",   //0:不回電,1:請回電
            "care_note": "已回電",  //關懷備註
            "reply_status": "0"  //0:未回覆,1:已回覆
          }
        ]
      }
    })
  }
  const url = apiUrl('care')
  return axios.get(url, {params})
}

export function updateCareAPI(id, data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('care', id)
  return axios.put(url, data)
}

export function batchReplyCareAPI(data) {
  const url = apiUrl('care', 'batch-reply')
  return axios.post(url, data)
}

export function batchUnreplyCareAPI(data) {
  const url = apiUrl('care', 'batch-unreply')
  return axios.post(url, data)
}

export function getRemindSettingCloseAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "clinic_code": null,
        "doctor_code": "0UeuIW4r3E04",
        "dates": [
          "2025-01-02",
          "2025-01-03"
        ]
      }
    })
  }
  const url = apiUrl('remind-setting-close')
  return axios.get(url, {params})
}

export function setRemindSettingCloseAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('remind-setting-close')
  return axios.post(url, data)
}

export function getCustomizeCareTagAPI(params) {
  if (useMock) {
    // eslint-disable-next-line no-console
    console.log('Using mock getCustomizeCareTagAPI with params:', params);
    const page = params.page || 1;
    const limit = params.limit || 10;
    const total = 25;
    const totalPages = Math.ceil(total / limit);

    const mockData = Array.from({ length: total }, (_, i) => {
      const id = i + 1;
      return {
        id: id,
        clinic_code: "0000000088",
        doctor_code: null,
        tag_name: `關懷項目 ${id}`,
        description: `這是關懷項目 ${id} 的詳細說明。`,
        tag_color: "#808080",
        is_active: "1",
        created_at: `2025-08-${String(15 + (id % 3)).padStart(2, '0')}T02:52:35.000000Z`,
        updated_at: `2025-08-${String(15 + (id % 3)).padStart(2, '0')}T02:52:35.000000Z`,
        message_templates: [
          {
            id: `${id}a`,
            tag_id: id,
            start_offset_days: `${id % 7}`,
            send_at_time: "12:00:00",
            message_type: "LINE_TEXT_IMAGE",
            message_content: `這是項目${id}的第一個關懷訊息。`,
            file: [],
            created_at: "2025-08-15 02:52:35"
          },
          {
            id: `${id}b`,
            tag_id: id,
            start_offset_days: `${(id % 7) + 2}`,
            send_at_time: "18:30:00",
            message_type: "LINE_TEXT_IMAGE",
            message_content: `這是項目${id}的第二個關懷訊息。`,
            file: [],
            created_at: "2025-08-16 02:52:35"
          }
        ]
      };
    });

    const paginatedData = mockData.slice((page - 1) * limit, page * limit);

    return Promise.resolve({
      data: {
        data: paginatedData,
        links: {
          first: `http://crm-tw.dentco.local/api/customize-care-tag?page=1`,
          last: `http://crm-tw.dentco.local/api/customize-care-tag?page=${totalPages}`,
          prev: page > 1 ? `http://crm-tw.dentco.local/api/customize-care-tag?page=${page - 1}` : null,
          next: page < totalPages ? `http://crm-tw.dentco.local/api/customize-care-tag?page=${page + 1}` : null,
        },
        meta: {
          current_page: page,
          from: (page - 1) * limit + 1,
          last_page: totalPages,
          path: `http://crm-tw.dentco.local/api/customize-care-tag`,
          per_page: limit,
          to: (page - 1) * limit + paginatedData.length,
          total: total,
        }
      }
    });
  }
  const url = apiUrl('customize-care-tag');
  return axios.get(url, { params });
}

export function getSingleCustomizeCareTagAPI(id, params) {
  if (useMock) {
    // eslint-disable-next-line no-console
    console.log(`Using mock getSingleCustomizeCareTagAPI for id: ${id} with params:`, params);
    const mockItem = {
      id: parseInt(id, 10),
      clinic_code: "0000000088",
      doctor_code: null,
      tag_name: `關懷項目 ${id}`,
      description: `這是關懷項目 ${id} 的詳細說明。`,
      tag_color: "#808080",
      is_active: "1",
      created_at: `2025-08-15T02:52:35.000000Z`,
      updated_at: `2025-08-15T02:52:35.000000Z`,
      message_templates: [
        {
          id: `${id}a`,
          tag_id: parseInt(id, 10),
          start_offset_days: "1",
          send_at_time: "12:00:00",
          message_type: "LINE_TEXT_IMAGE",
          message_content: `這是項目${id}的第一個關懷訊息。`,
          file: [],
          created_at: "2025-08-15 02:52:35"
        }
      ]
    };
    return Promise.resolve({ data: { data: mockItem } });
  }
  const url = apiUrl('customize-care-tag', id);
  return axios.get(url, { params });
}

export function createCustomizeCareTagAPI(data) {
  if (useMock) {
    // eslint-disable-next-line no-console
    console.log('Using mock createCustomizeCareTagAPI with data:', data);
    return Promise.resolve({ data: { message: '新增成功' } });
  }
  const url = apiUrl('customize-care-tag');
  return axios.post(url, data);
}

export function updateCustomizeCareTagAPI(id, data) {
  if (useMock) {
    // eslint-disable-next-line no-console
    console.log(`Using mock updateCustomizeCareTagAPI for id: ${id} with data:`, data);
    return Promise.resolve({ data: { message: '修改成功' } });
  }
  const url = apiUrl('customize-care-tag', id);
  // Real API might need FormData and a _method field for PUT
  return axios.post(url, data);
}

export function deleteCustomizeCareTagAPI(id, params) {
  if (useMock) {
    // eslint-disable-next-line no-console
    console.log(`Using mock deleteCustomizeCareTagAPI for id: ${id} with params:`, params);
    return Promise.resolve({ data: { message: '刪除成功' } });
  }
  const url = apiUrl('customize-care-tag', id);
  return axios.delete(url, { params });
}

export function getCustomizeCareSendQueueAPI(params) {
  // This is the real API call for the pending list
  const url = apiUrl('customize-care-send-queue');
  return axios.get(url, { params });
}

// 精確查詢需逐頁保留 owner 與 reserve_no，不能跟隨缺少篩選條件的 links。
export async function getReserveCareSchedulesAPI(reserveNo, params, isCurrent = () => true) {
  if (!/^[1-9]\d*$/.test(String(reserveNo))) throw new Error('缺少有效約診 ID');
  const groups = [];
  let page = 1;
  let lastPage = 1;
  do {
    if (!isCurrent()) return null;
    const response = await getCustomizeCareSendQueueAPI({ ...params, reserve_no: reserveNo, page, per_page: 100 });
    if (!isCurrent()) return null;
    const body = response.data;
    if (!body || !Array.isArray(body.data) || !body.meta || Number(body.meta.current_page) !== page) throw new Error('排程分頁資料不符');
    lastPage = Number(body.meta.last_page);
    if (!Number.isInteger(lastPage) || lastPage < page || body.data.some(group => String(group.reserve_no) !== String(reserveNo))) throw new Error('約診排程資料不符');
    groups.push(...body.data);
    page++;
  } while (page <= lastPage);
  return { data: { data: groups } };
}

export function batchUpdateCareMessagesAPI(data) {
  if (useMock) {
    // eslint-disable-next-line no-console
    console.log('Placeholder: batchUpdateCareMessagesAPI called with:', data);

    return Promise.resolve({
      data: {
        message: '更新成功 (開發模式)',
      },
    });
  }
  const url = apiUrl('customize-care-send-queue', 'batch-update');
  return axios.put(url, data);
}

export function updateCareSendQueueCrmNoteAPI(id, data) {
  const url = apiUrl('customize-care-send-queue', id, 'update-note');
  return axios.put(url, data);
}
